import yup from '../../../config/yup';

export const ethosWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('ethosWriter'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  connectionKey: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    debug: yup.boolean(),
    apiKey: yup.string(),
    rootUrl: yup.string(),
    dataModelVersion: yup.string(),
    contentType: yup.string(),
    accept: yup.string(),
    interval: yup.number(),
    count: yup.number(),
    path: yup.string().required('Path is required'),
  }),
});
